// Simple, bulletproof mobile menu
(function() {
  'use strict';
  
  let isMenuOpen = false;
  
  function toggleMenu() {
    const menu = document.getElementById('mobile-menu');
    const button = document.getElementById('mobile-menu-button');
    
    if (!menu || !button) {
      console.error('Mobile menu elements not found');
      return;
    }
    
    if (isMenuOpen) {
      // Close menu
      menu.classList.add('hidden');
      button.classList.remove('hamburger-open');
      document.body.classList.remove('mobile-menu-open');
      isMenuOpen = false;
      
      // Reset submenus
      document.querySelectorAll('.mobile-submenu-content').forEach(sub => {
        sub.classList.add('hidden');
        sub.classList.remove('opacity-100');
        sub.classList.add('opacity-0');
      });
      
      const mainMenu = document.getElementById('main-mobile-menu');
      if (mainMenu) mainMenu.classList.remove('hidden');
      
    } else {
      // Open menu
      menu.classList.remove('hidden');
      button.classList.add('hamburger-open');
      document.body.classList.add('mobile-menu-open');
      isMenuOpen = true;
      
      // Reset all items to not have fade-in, then animate them
      const items = menu.querySelectorAll('.mobile-menu-item, .mobile-account-link, .mobile-journal-section');
      items.forEach(item => item.classList.remove('fade-in'));
      
      setTimeout(() => {
        items.forEach((item, i) => {
          setTimeout(() => item.classList.add('fade-in'), i * 20);
        });
      }, 10);
    }
  }
  
  function showSubmenu(menuTitle) {
    const mainMenu = document.getElementById('main-mobile-menu');
    const submenu = document.querySelector(`[data-parent="${menuTitle}"]`);
    
    if (!mainMenu || !submenu) return;
    
    mainMenu.classList.add('hidden');
    submenu.classList.remove('hidden');
    
    // Reset submenu items
    const items = submenu.querySelectorAll('.submenu-item');
    items.forEach(item => item.classList.remove('fade-in'));
    
    setTimeout(() => {
      submenu.classList.remove('opacity-0');
      submenu.classList.add('opacity-100');
      
      items.forEach((item, i) => {
        setTimeout(() => item.classList.add('fade-in'), i * 20);
      });
    }, 10);
  }
  
  function hideSubmenu() {
    const mainMenu = document.getElementById('main-mobile-menu');
    const allSubmenus = document.querySelectorAll('.mobile-submenu-content');
    
    if (!mainMenu) return;
    
    allSubmenus.forEach(sub => {
      sub.classList.add('hidden');
      sub.classList.remove('opacity-100');
      sub.classList.add('opacity-0');
    });
    
    mainMenu.classList.remove('hidden');
    
    // Reset all items first
    const items = mainMenu.querySelectorAll('.mobile-menu-item, .mobile-account-link, .mobile-journal-section');
    items.forEach(item => item.classList.remove('fade-in'));
    
    setTimeout(() => {
      items.forEach((item, i) => {
        setTimeout(() => item.classList.add('fade-in'), i * 20);
      });
    }, 10);
  }
  
  // Event delegation
  function handleClick(e) {
    // Mobile menu button
    if (e.target.closest('#mobile-menu-button')) {
      e.preventDefault();
      toggleMenu();
      return;
    }
    
    // Mobile menu items with submenus
    const menuItem = e.target.closest('.mobile-menu-item[data-menu-title]');
    if (menuItem) {
      e.preventDefault();
      const menuTitle = menuItem.getAttribute('data-menu-title');
      showSubmenu(menuTitle);
      return;
    }
    
    // Submenu back buttons
    if (e.target.closest('.mobile-submenu-back')) {
      e.preventDefault();
      hideSubmenu();
      return;
    }
    
    // Close menu when clicking outside
    if (isMenuOpen && !e.target.closest('#mobile-menu') && !e.target.closest('#mobile-menu-button')) {
      toggleMenu();
    }
  }
  
  // Initialize immediately
  function init() {
    document.addEventListener('click', handleClick);
    console.log('Mobile menu initialized');
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();